import { render, staticRenderFns } from "./PostCategoryForm.vue?vue&type=template&id=3bfe95ec"
import script from "./PostCategoryForm.vue?vue&type=script&lang=js"
export * from "./PostCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports